/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Termsacceptancerequired2Inputs */

const en_termsacceptancerequired2 = /** @type {(inputs: Termsacceptancerequired2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You must accept the terms and conditions`)
};

const de_termsacceptancerequired2 = /** @type {(inputs: Termsacceptancerequired2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du musst die AGB akzeptieren`)
};

/**
* | output |
* | --- |
* | "You must accept the terms and conditions" |
*
* @param {Termsacceptancerequired2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const termsacceptancerequired2 = /** @type {((inputs?: Termsacceptancerequired2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Termsacceptancerequired2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_termsacceptancerequired2(inputs)
	return de_termsacceptancerequired2(inputs)
});
export { termsacceptancerequired2 as "termsAcceptanceRequired" }